import { render, staticRenderFns } from "./MemberNoticeEdit.vue?vue&type=template&id=dde5a872&scoped=true&"
import script from "./MemberNoticeEdit.vue?vue&type=script&lang=js&"
export * from "./MemberNoticeEdit.vue?vue&type=script&lang=js&"
import style0 from "./MemberNoticeEdit.vue?vue&type=style&index=0&id=dde5a872&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde5a872",
  null
  
)

export default component.exports